import { ArrowRight } from 'lucide-react';
import { ArcheIconImg, DefaultArcheIcon } from '@/lib/arche-icon-url';
import { archePath } from '@/lib/arche-url';

interface ArcheSuggestion {
  archId: string;
  slug?: string | null;
  name: string;
  simpleDescription: string;
  imageRef: string | null;
}

interface ArcheSuggestionsRowProps {
  suggestions: ArcheSuggestion[];
  onArcheClick: (archId: string) => void;
}

export function ArcheSuggestionsRow({ suggestions, onArcheClick }: ArcheSuggestionsRowProps) {
  if (suggestions.length === 0) return null;

  return (
    <div className="ml-11 mt-3">
      <p className="text-xs text-muted-foreground mb-2 font-medium uppercase tracking-wide">
        Suggested Arches
      </p>
      <div className="flex flex-col gap-2">
        {suggestions.slice(0, 3).map((arche) => (
          <button
            key={arche.archId}
            onClick={() => onArcheClick(archePath(arche))}
            className="flex items-center gap-2.5 p-2.5 rounded-lg bg-card border border-border hover:border-primary/50 hover:bg-accent/50 transition-all text-left group min-w-0"
          >
            {arche.imageRef ? (
              <ArcheIconImg
                imageRef={arche.imageRef}
                size={64}
                alt={arche.name}
                className="w-8 h-8 rounded-md object-cover flex-shrink-0"
              />
            ) : (
              <DefaultArcheIcon className="w-8 h-8 rounded-md flex-shrink-0" />
            )}
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-1">
                <span className="text-sm font-medium text-foreground">{arche.name}</span>
                <ArrowRight className="h-3 w-3 text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0" />
              </div>
              <p className="text-xs text-muted-foreground">{arche.simpleDescription}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
